<div class="chart-area-panel">
  <!--<inner-loader>-->
    <div class="menu-container">
      <button mat-button title="Refresh" (click)="refreshChart(reportIdentifier, selectedChartType)">
        <i class="fa fa-refresh"></i>
      </button>

      <button mat-button [matMenuTriggerFor]="chartTypeMenu" title="Select chart type">
        <i [ngClass]="getSelectedChartIcon()"></i>
      </button>
      <mat-menu #chartTypeMenu="matMenu">
        <button mat-menu-item *ngFor="let item of chartTypes" (click)="onChartTypeClick(item)">
          <i class="chart-type-icon" [ngClass]="getChartIcon(item)"></i>
          {{getChartDisplayName(item)}}
        </button>
      </mat-menu>

      <button mat-button [matMenuTriggerFor]="chartExportMenu" title="Export chart">
        <i class="fa fa-download"></i>
      </button>
      <mat-menu #chartExportMenu="matMenu">
        <button mat-menu-item (click)="printChart()">Print chart</button>
        <button mat-menu-item (click)="downloadImage('png')">Download PNG image</button>
        <button mat-menu-item (click)="downloadImage('jpeg')">Download JPEG image</button>
        <button mat-menu-item (click)="downloadPdf()">Download PDF document</button>
        <button mat-menu-item (click)="downloadImage('svg+xml')">Download SVG vector image</button>
      </mat-menu>
    </div>

    <div id="chart-area" *ngIf="chartOptions">
      <arm-highchart [options]="chartOptions"></arm-highchart>
    </div>
  <!--</inner-loader> -->
</div>
